import {FormControl, FormField} from 'platform/components';

import {i18n} from '@dms/i18n';

import {PurchasePriceRuleFormValues} from '../schemas/PurchasePriceRuleFormSchema';

interface PurchasePriceRuleNameFieldProps {
  control: FormControl<PurchasePriceRuleFormValues>;
  /** The name of the system rule cannot be changed. */
  isSystemRule: boolean;
  /** Called when the user types into the name. */
  onUserChange: VoidFunction;
  baseTestId: (suffix: string) => string;
}

export function PurchasePriceRuleNameField(props: PurchasePriceRuleNameFieldProps) {
  return (
    <FormField
      control={props.control}
      name="name"
      type="text"
      label={i18n.t('page.settings.purchasePrice.ruleEditor.name.title')}
      isDisabled={props.isSystemRule}
      onChange={props.onUserChange}
      isRequired
      data-testid={props.baseTestId('name')}
    />
  );
}
